<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.smAndDown" persistent max-width="600px">
    <ExecutionResultsDialog ref="executionResultsDialog" />
    <template v-slot:activator="{ on }">
      <SecondaryBtn light v-on="on" color="info" icon="system_update">
        Install Services
      </SecondaryBtn>
    </template>
    <v-card dark>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Install Services</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click.native="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card>
      <v-card-text>
        <v-autocomplete v-model="formObject.tenantIds" :items="tenants" multiple label="Tenants" item-text="RoleName" item-value="Id" />
        <v-select v-model="formObject.serviceIds" :items="services" multiple label="Services" item-text="DisplayName" item-value="Id" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <PrimaryBtn color="success" icon="system_update" :disabled="false" :loading="isSaving" @click="submit()">
          Install
        </PrimaryBtn>
        <CloseBtn primary :disabled="isBlocked" @click="close()" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ServiceForm from '../ServiceForm'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const services = createNamespacedHelpers('services')
  const admin = createNamespacedHelpers('admin')

  export default {
    components: {
      ServiceForm,
    },
    data: () => ({
      dialog: false,
      isValidated: false,
      isBlocked: false,
      isSaving: false,
      releaseTag: '',
      formObject: {},
      initialObject: {
        serviceIds: [],
        tenantIds: [],
      },
    }),
    computed: {
      ...services.mapState(['services']),
      ...admin.mapGetters(['tenants']),
    },
    methods: {
      ...services.mapActions(['bulkInstallServices']),
      ...admin.mapActions(['getRoleList']),
      close() {
        this.reset()
        this.dialog = false
      },
      async submit() {
        try {
          //test this and implement execution logs nesting view
          let executionResults = await this.bulkInstallServices(this.formObject)
          this.$refs.executionResultsDialog.show(executionResults)
        } catch (error) {
          this.$refs.executionResultsDialog.show(error)
        }
      },
      reset() {
        this.formObject = JSON.parse(JSON.stringify(this.initialObject))
      },
      setStateSaving(value) {
        this.isSaving = value
        this.isBlocked = value
      },
    },
    mounted() {
      this.getRoleList()
      this.reset()
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>